import DashboardLayout from "../../components/layout/DashboardLayout";
import usePageTitle from "../../hooks/usePageTitle";
import ExchangePortfolioInfo from "../../components/exchange-portfolio/ExchangePortfolioInfo";
import ConnectedExchanges from "../../components/exchange-portfolio/ConnectedExchanges";
import ExchangeTradeHistory from "../../components/portfolio/portfolio-section/ExchangeTradeHistory";

function ExchangePortfolio() {
  usePageTitle("Portfolio");

  return (
    <DashboardLayout>
      <ExchangePortfolioInfo />
      <ConnectedExchanges />
      <ExchangeTradeHistory />
    </DashboardLayout>
  );
}

export default ExchangePortfolio;
